<div class="chat-conversations pt-2">

	<slick-tabs [(tabIndex)]="tabIndex" (tabChange)="onTabChanged()">
		<slick-tab header="Open">
			<ng-container *ngIf="tabIndex === 0" [ngTemplateOutlet]="renderCoversations" [ngTemplateOutletContext]="{ conversations: visibleConversations, isOpen: true }"></ng-container>
		</slick-tab>

		<slick-tab header="Closed">
			<ng-container *ngIf="tabIndex === 1" [ngTemplateOutlet]="renderCoversations" [ngTemplateOutletContext]="{ conversations: visibleConversations, isOpen: false }"></ng-container>
		</slick-tab>
	</slick-tabs>
</div>

<ng-template #renderCoversations let-conversations="conversations" let-isOpen="isOpen">
	<div class="d-flex flex-column" style="min-height: calc(100vh - 130px); max-height: calc(100vh - 130px);">
		<!-- Header -->
		<div>
			<div *ngIf="companyTextNumber" class="mx-2" style="font-size: 12px; color: #6c757d;">
				<span class="fw-bold">My Number:</span> {{companyTextNumber}}
			</div>
			<div class="d-flex mx-2 pt-2 mb-1">
				<div class="flex-fill me-1">
					<div class="input-group">
						<span class="input-group-text"><span class="far fa-search"></span></span>
						<input type="text"
							   (keyup)="onKeyUp()"
							   class="form-control"
							   autocomplete="off"
							   placeholder="Search..."
							   [(ngModel)]="textChatStore.searchText" />
					</div>
				</div>
				<div *ngIf="isOpen === true">
					<button type="button" class="btn btn-outline-primary" (click)="showStartNewConversationDialog()"><i class="far fa-plus"></i></button>
				</div>
			</div>

			<div *ngIf="selectedLocations?.length > 1" class="d-flex ps-2 mb-1 align-items-center  flex-wrap" style="font-size: .8rem; line-height: 1rem;">
				<div>Locations:</div>
				<div *ngFor="let selectedLocation of selectedLocations" class="ms-2">
					<input type="checkbox" [ngModel]="selectedLocation.checked" (change)="onLocationChanged(selectedLocation)" style="margin-right: 3px;" />{{selectedLocation.locationName}}
				</div>
			</div>

			<div class="border-bottom"></div>
		</div>

		<!-- Body -->
		<div class="flex-fill" style="overflow-y: auto; max-height: calc(100vh - 200px)" >
			<div *ngIf="!conversations" class="p-2">Loading...</div>
			<div *ngIf="conversations && conversations.length === 0" class="p-2">
				No conversations found
			</div>
			<div *ngIf="conversations && conversations.length > 0">
				<div *ngFor="let conversation of conversations" style="cursor: pointer" class="conversation px-3 py-2" [ngClass]="{ 'outline-card': (conversation.textChatConversationId === activeConversation?.textChatConversationId || textChatStore.scrubPhoneNumber(conversation.customerPhoneNumber) === textChatStore.scrubPhoneNumber(activeConversation?.customerPhoneNumber) ) }" (click)="selectConversation(conversation)">
					<div class="d-flex align-items-start">
						<div class="flex-fill mb-1" style="font-size: 18px; line-height: 18px;">
							<span *ngIf="conversation.customerFullName">{{conversation.customerFullName}}</span>
							<span *ngIf="!conversation.customerFullName">{{conversation.customerPhoneNumber}}</span>
						</div>
						<div *ngIf="conversation.unreadMessages > 0" class="badge badge-danger bg-danger px-1 " style="font-size: 14px">{{conversation.unreadMessages}}</div>
					</div>
					<div style="font-size: 14px; line-height: 12px;" class="text-dimmed">
						<div *ngIf="conversation.isAssigned === true">Assigned To: {{conversation.assignedToUserFullName}}</div>
						<div *ngIf="conversation.isAssigned === false">Not Assigned</div>
						<div class="ellipses mt-1" style="font-size: 12px; line-height: 14px;">{{conversation.lastTextBody}}</div>
						<div style="font-size: 10px; line-height: 12px;">{{conversation.lastTextSentDate | date: 'M/d/yyyy h:mm:ss a'}}<span *ngIf="!conversation.isClosed" (click)="closeConversation($event, conversation)" class="text-danger link-underline" style="float:right; line-height:14px"> Close</span></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<slick-dialog #startConversationDialogRef width="450" header="Start New Conversation">
	<div class="input-group">
		<span class="input-group-text"><span class="far fa-user"></span></span>
		<input #autoCompleteInputRef
			   type="text"
			   class="form-control"
			   autocomplete="off"
			   placeholder="Customer Name or Phone #"
			   [(ngModel)]="newConversationSearchText" />

		<button [disabled]="!newConversationSearchText" class="ms-2 btn btn-outline-primary" (click)="startNewConversation()"><i class="far fa-arrow-right"></i> Go</button>

	</div>

	<slick-auto-complete [inputRef]="autoCompleteInputRef"
						 textField="cellPhone"
						 listWidth="500"
						 [items]="results"
						 (onRefresh)="findCustomer()"
						 (onSelect)="onSelect($event)"
						 (onFreeformTextSelect)="onFreeformTextSelect($event)">
		<ng-template let-result [slickAutoCompleteListItemTemplate]>
			<ul class="customer-list-item">
				<li *ngIf="result.cellPhone" style="font-weight: bold; font-size: 16px;" class="mt-1 mb-2">{{ result.cellPhone }}</li>
				<li *ngIf="result.customerCompanyName" style="font-weight: bold; font-size: 12px;">{{ result.customerCompanyName }}</li>
				<li *ngIf="result.customerFullName && result.customerCompanyName">{{ result.customerFullName }}</li>
				<li *ngIf="result.customerFullName && !result.customerCompanyName" style="font-weight: bold; font-size: 12px;">{{ result.customerFullName }}</li>

				<li *ngIf="result.address1">{{ result.address1 }}</li>
				<li *ngIf="result.address2">{{ result.address2 }}</li>
				<li>
					<span *ngIf="result.city">{{ result.city }},</span>
					<span *ngIf="result.state">{{ result.state }},</span>
					<span *ngIf="result.zipcode">{{ result.zipcode }}</span>
				</li>

			</ul>

		</ng-template>
	</slick-auto-complete>


</slick-dialog>